import { Box, Text } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '../../../Dashboard.trans.json';
import AlertErrorsIndicator from './AlertErrorsIndicator';
import styles from './portalsNotificationsCard.module.scss';

function RemainingEntityCard({ entity, type }) {
  const cardLabel = Trans(
    translations,
    type === 'property' ? 'OtherProperties' : 'OtherPortals'
  );
  const errorAccount = entity.reduce((acc, elem) => acc + elem.errors, 0);
  const alertAccount = entity.reduce((acc, elem) => acc + elem.alerts, 0);
  return (
    <Box className={styles.remainingEntityCard}>
      <Text variant="body.fontSize14" className={styles.cardLabel}>
        {cardLabel}
      </Text>
      <AlertErrorsIndicator errors={errorAccount} alerts={alertAccount} />
    </Box>
  );
}

export default RemainingEntityCard;
